export default __webpack_public_path__ + "static/media/bearshamanhead.e59a34c8.png";